import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Using base-href safe relative path so it works at root and subpaths like /CleverEnergy/
const CONFIG_URL = './assets/config/appconfig.json';

(async () => {
  // 1) Try to preload config
  try {
    const res = await fetch(CONFIG_URL, { cache: 'no-cache' });
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
    const cfg = await res.json();
    sessionStorage.setItem('appconfig', JSON.stringify(cfg));
  } catch (err) {
    console.error('Failed to preload appconfig.json', err);
    sessionStorage.setItem('configLoadFailed', 'true');
    // minimal fallback so providers don’t crash
    sessionStorage.setItem('appconfig', JSON.stringify({}));
  }

  // 2) Always bootstrap the app (even if config failed)
  try {
    await platformBrowserDynamic().bootstrapModule(AppModule);
  } catch (bootstrapErr) {
    console.error('Angular bootstrap failed:', bootstrapErr);
  }
})();